export { default } from './CicEnteredBy';
